import { Component, NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../services/theme.service';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class ThemeSwitcherComponent {
  public themeService = inject(ThemeService);
  private langService = inject(LanguageService, { optional: true });

  get isDark(): boolean {
    return this.themeService.currentTheme === 'dark';
  }

  get tooltipText(): string {
    const isMr = this.langService?.currentLang === 'mr';
    if (this.isDark) {
      return isMr ? 'लाइट मोड चालू करा (Light Mode)' : 'Switch to Light Theme';
    } else {
      return isMr ? 'डार्क मोड चालू करा (Dark Mode)' : 'Switch to Dark Theme';
    }
  }

  onButtonClick(): void {
    this.themeService.switchTheme();
  }
}

@NgModule({
  imports: [ThemeSwitcherComponent],
  exports: [ThemeSwitcherComponent],
})
export class ThemeSwitcherModule {}